var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H8V8H20V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H8V12H20V10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H8V16H14V14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H8V26H12V24Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30H6C4.897 30 4 29.103 4 28V4C4 2.897 4.897 2 6 2H22C23.103 2 24 2.897 24 4V13H22V4H6V28H12V30Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20C26 20.552 25.552 21 25 21C24.448 21 24 20.552 24 20C24 19.448 24.448 19 25 19C25.552 19 26 19.448 26 20Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28H18.586L23.792 22.794L24.332 22.917C24.574 22.973 24.792 23 25 23C26.654 23 28 21.654 28 20C28 18.346 26.654 17 25 17C23.346 17 22 18.346 22 20C22 20.207 22.027 20.426 22.083 20.669L22.206 21.208L17 26.414V28ZM19.414 30H15V25.586L20.034 20.552C20.011 20.365 20 20.182 20 20C20 17.243 22.243 15 25 15C27.757 15 30 17.243 30 20C30 22.939 27.482 25.33 24.448 24.966L19.414 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.1aa908f76db7379c5ceb2b7aeb7f6f38.svg";
export { ForwardRef as ReactComponent };